import { render, staticRenderFns } from "./stock-adjustment-v2.vue?vue&type=template&id=5681c1c4"
import script from "./stock-adjustment-v2.vue?vue&type=script&lang=js"
export * from "./stock-adjustment-v2.vue?vue&type=script&lang=js"
import style0 from "./stock-adjustment-v2.vue?vue&type=style&index=0&id=5681c1c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports